/**** ENOVA FOOTER ACCORDION ****/
var acc = document.getElementsByClassName("footer__item-title");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}




(function ($) {
      $('.mega-menu__column ul.list--unstyled').each(function () {
        var lista = $(this).find('li').length;
        if (lista > 3) {
          $('li', this).eq(3).nextAll().hide().addClass('toggleable');
          $(this).append('<li class="enova-show-more">Ver Más</li>');
        }
      });
      $('.mega-menu__column ul.list--unstyled').on('click', '.enova-show-more', function () {
        if ($(this).hasClass('less')) {
          $(this).text('Ver Más').removeClass('less');
        } else {
          $(this).text('Ver Menos').addClass('less');
        }
        $(this).siblings('li.toggleable').slideToggle();
      });
    })(jQuery);




/**** ENOVA HEADER ACCORDION ****/
/*var mmt = document.getElementsByTagName("button");
var e;
for (e = 0; e < mmt.length; e++) {
  mmt[e].addEventListener("click", function() {
    this.classList.toggle("active-ver-mas");
    var panelmenu = this.nextElementSibling;
    if (panelmenu.style.maxHeight) {
      panelmenu.style.maxHeight = null;
    } else {
      panelmenu.style.maxHeight = panelmenu.scrollHeight + "px";
    } 
  });
}*/